<div
  id="sessionExpiredPage"
  class="errorpage">
  <div class="errorpage-logo-container">
    <img
      src="assets/allianz-logo.png"
      alt="allianz-logo"
      class="errorpage-logo-img" />
  </div>
  <div class="errorpage-content">
    <nx-icon
      name="exclamation-circle"
      size="m"
      class="nx-margin-bottom-s"></nx-icon>
    <div class="errorpage-headline">
      {{ "sessionExpiredPage.header" | text }}
    </div>
    <div class="errorpage-msg">{{ "sessionExpiredPage.text" | text }}</div>
  </div>
</div>
